import React from 'react';
import { Flex, Text, Tooltip } from '@tapresearch/ui/components';
import { AxisTickProps } from '@nivo/axes';
import { OpacityTransitionBox } from '../../../../../shared/OpacityTransitionBox';

export function CustomTick(tick: AxisTickProps<string>) {
  return (
    <g transform={`translate(${tick.x - 120},${tick.y - 24})`}>
      <foreignObject overflow="visible" width="110" height="45">
        <OpacityTransitionBox>
          <Flex h="full" alignItems="center" justifyContent="flex-end">
            <Text
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
              align="center"
              textAlign="right"
            >
              <Tooltip label={tick.value} padding="2" borderRadius="md">
                {tick.value}
              </Tooltip>
            </Text>
          </Flex>
        </OpacityTransitionBox>
      </foreignObject>
    </g>
  );
}
